<template>
  <b-modal id="modal-config-positions" v-model="modal" size="lg" hide-footer>
    <template #modal-title>CONFIGURAR PORCENTAJES POR POSICION</template>
    <vs-button type="button" success class="mb-3" @click="addConfig">
      AGREGAR CONFIG <span class="ms-2 uil-plus text-light"></span>
    </vs-button>
    <div class="grid-config-positions">
      <span>DESDE</span>
      <span>HASTA</span>
      <span>PORCENTAJE</span>
    </div>
    <div class="grid-config-positions" v-for="(item, i) in positions" :key="i">
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="DESDE"
        v-model="item.minPos"
      />
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="DESDE"
        v-model="item.maxPos"
      />
      <vs-input
        class="mb-2 shadow-lg"
        border
        placeholder="DESDE"
        v-model="item.percentage"
      />
      <div class="d-flex">
        <vs-button type="button" success @click="() => save(item)">
          <span class="uil-check text-light"></span>
        </vs-button>
        <vs-button type="button" @click="() => remove(item)">
          <span class="uil-trash-alt text-light"></span>
        </vs-button>
      </div>
    </div>
    <div>
      <span class="text-danger">
        PORCENTAJE REPARTIDO: {{ getTotalPercentage }}% DE
        {{ amountBills }}
      </span>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    amountBills: {
      type: Number,
      default: 2000,
    },
  },
  data() {
    return {
      modal: false,
      tournament: null,
      positions: [
        {
          id: 'mock-1',
          minPos: 1,
          maxPos: 10,
          percentage: 85,
        },
      ],
    };
  },
  computed: {
    getTotalPercentage() {
      return this.positions.reduce(
        (acc, item) => acc + Number(item.percentage),
        0
      );
    },
    ...mapGetters({
      text: 'tournaments/getMessage',
      success: 'tournaments/isSuccess',
    }),
  },
  methods: {
    closeModa() {
      this.modal = false;
    },
    addConfig() {
      this.positions.push({
        minPos: 0,
        maxPos: 0,
        percentage: 0,
        id: `mock-${this.positions.length + 1}`,
      });
    },
    async save(item) {
      if (this.getTotalPercentage > 100) {
        this.$swal.fire({
          title: 'Error',
          text: 'El porcentaje total no puede ser mayor a 100%',
          icon: 'error',
        });
        return;
      }

      const position = {
        tournament: this.tournament,
        ...item,
      };

      if (item.id.startsWith('mock-')) await this.add({ position });
      else await this.update({ position });

      this.$swal.fire({
        title: this.text,
        icon: this.success ? 'success' : 'error',
        timer: 2000,
      });
    },
    async remove(item) {
      if (item.id.startsWith('mock-')) {
        this.positions = this.positions.filter((i) => i.id !== item.id);
        return;
      }

      const { isConfirmed } = await this.$swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción eliminará la configuración de esta posición.',
        icon: 'warning',
        showCancelButton: true,
      });

      if (!isConfirmed) return;

      await this.destroy(item.id);
      this.$swal.fire({
        title: this.text,
        icon: this.success ? 'success' : 'error',
        timer: 2000,
      });

      if (this.success)
        this.positions = this.positions.filter((i) => i.id !== item.id);
    },
    ...mapActions({
      add: 'tournaments/addPosition',
      update: 'tournaments/updatePosition',
      destroy: 'tournaments/deletePosition',
    }),
  },
};
</script>

<style lang="scss" scoped>
.grid-config-positions {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 10px;
}
</style>
